import { jsx, jsxs } from "react/jsx-runtime";
import { c } from "react-compiler-runtime";
import { DeprecationReason } from "./deprecation-reason.js";
import { TypeLink } from "./type-link.js";
import { renderType } from "./utils.js";
/* empty css               */
const FieldCard = (t0) => {
  const $ = c(19);
  const {
    field
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = /* @__PURE__ */ jsx("span", { className: "graphiql-doc-explorer-type-badge", children: "FIELD" });
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] !== field.name) {
    t2 = /* @__PURE__ */ jsx("span", { className: "graphiql-doc-explorer-field-card-name", children: field.name });
    $[1] = field.name;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = /* @__PURE__ */ jsx("span", { className: "graphiql-doc-explorer-field-card-colon", "aria-hidden": "true", children: ":" });
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  let t4;
  if ($[4] !== field.type) {
    t4 = renderType(field.type, _temp);
    $[4] = field.type;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  let t5;
  if ($[6] !== t4) {
    t5 = /* @__PURE__ */ jsx("span", { className: "graphiql-doc-explorer-field-card-type", children: t4 });
    $[6] = t4;
    $[7] = t5;
  } else {
    t5 = $[7];
  }
  let t6;
  if ($[8] !== t2 || $[9] !== t5) {
    t6 = /* @__PURE__ */ jsxs("div", { className: "graphiql-doc-explorer-field-card-header", children: [
      t1,
      t2,
      t3,
      t5
    ] });
    $[8] = t2;
    $[9] = t5;
    $[10] = t6;
  } else {
    t6 = $[10];
  }
  let t7;
  if ($[11] !== field.description) {
    t7 = field.description && /* @__PURE__ */ jsx("p", { className: "graphiql-doc-explorer-field-card-description", children: field.description });
    $[11] = field.description;
    $[12] = t7;
  } else {
    t7 = $[12];
  }
  let t8;
  if ($[13] !== field) {
    t8 = "deprecationReason" in field && field.deprecationReason ? /* @__PURE__ */ jsx(DeprecationReason, { preview: false, children: field.deprecationReason }) : null;
    $[13] = field;
    $[14] = t8;
  } else {
    t8 = $[14];
  }
  let t9;
  if ($[15] !== t6 || $[16] !== t7 || $[17] !== t8) {
    t9 = /* @__PURE__ */ jsxs("div", { className: "graphiql-doc-explorer-field-card", children: [
      t6,
      t7,
      t8
    ] });
    $[15] = t6;
    $[16] = t7;
    $[17] = t8;
    $[18] = t9;
  } else {
    t9 = $[18];
  }
  return t9;
};
function _temp(namedType) {
  return /* @__PURE__ */ jsx(TypeLink, { type: namedType });
}
export {
  FieldCard
};
//# sourceMappingURL=field-card.js.map
